export default __webpack_public_path__ + "static/media/exp_P.6ff2c2cc.png";